import { render, staticRenderFns } from "./DiscoveryManageList.vue?vue&type=template&id=997224b4&scoped=true"
import script from "./DiscoveryManageList.vue?vue&type=script&lang=js"
export * from "./DiscoveryManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997224b4",
  null
  
)

export default component.exports